module.exports = __webpack_public_path__ + "img/grand-osasis-cancun-room-3.e3494f7e.jpg";